module.exports = __webpack_public_path__ + "img/event_540.a766de0f.png";